import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPoints, setCo2Data } from "./store/pointsSlice";
import { fetchPoints, fetchCo2Data } from "./services/api";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AboutPage from "./pages/AboutPage/AboutPage";
import MapPage from "./pages/MapPage/MapPage";
import MethodologyPage from "./pages/MethodologyPage/MethodologyPage";
import DataPage from "./pages/DataPage/DataPage";
import "./pages/pages-shared.css";
import "./App.css";
import "./styles.css";

function App() {
    const [activeTab, setActiveTab] = useState("about");
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const loadData = async () => {
            try {
                const [pointsData, co2Data] = await Promise.all([
                    fetchPoints(),
                    fetchCo2Data(),
                ]);

                dispatch(setPoints(pointsData));
                dispatch(setCo2Data(co2Data));
            } catch (error) {
                // console.error("Error loading data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, [dispatch]);

    if (isLoading) {
        return (
            <div
                className="loader-container"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/illustrations/background.png)`,
                }}
            >
                <img
                    className="loader-logo"
                    src={`${process.env.PUBLIC_URL}/logo_geocarbon_full.svg`}
                    alt="Геокарбон"
                />
                <div className="loader"></div>
                <p className="loader-text">Загружаем данные проекта…</p>
            </div>
        );
    }

    return (
        <div
            className="site-root tab-illustrated"
            style={{
                backgroundImage: `linear-gradient(rgba(246, 247, 251, 0.55), rgba(246, 247, 251, 0.55)), url(${process.env.PUBLIC_URL}/illustrations/background.png)`,
            }}
        >
            <Header activeTab={activeTab} onChangeTab={setActiveTab} />

            {activeTab === "about" && <AboutPage onChangeTab={setActiveTab} />}
            {activeTab === "map" && <MapPage />}
            {activeTab === "methodology" && (
                <MethodologyPage onChangeTab={setActiveTab} />
            )}
            {activeTab === "data" && <DataPage />}

            <Footer />
        </div>
    );
}

export default App;
